<template>
  <div class="main-visuals">
    <my-header :page_name="$t('navigation.headerTitles.visuals')" show_usermenu></my-header>

    <tree style="max-height:90vh"></tree>
  </div>
</template>

<script>
import Header from "../../components/reusable/header/Header";
import Tree from "../../components/common/mapTree/Tree";
import { mapGetters } from "vuex";
export default {
  created() {
    this.$store.commit("setLoading", true);
    this.$store.commit("setShowCheckboxes", false);
    this.$store
      .dispatch("getVisualsMap")
      .then(() => {
        this.$store.commit("setLoading", false);
      })
      .catch(() => {
        this.$store.commit("setLoading", false);
      });
  },
  computed: {
    ...mapGetters(["getVisualsMap"]),
  },
  components: {
    myHeader: Header,
    Tree,
  },
};
</script>
<style scoped>
.main-visuals{
  background-color: var(--main-background);
}
</style>